export default "__VITE_ASSET__DI6y6ybG__"